import CRASH88Actions from './CRASH88Actions'

export default class ROYALGAMINGActions extends CRASH88Actions {
  constructor(formData) {
    super(formData)
    this.formData = formData

    this.constantTxnData = {
      platform: 'ROYALGAMING',
      gameType: 'LIVE',
      gameCode: 'RG-LIVE-002',
    }

    this.gameName = '7 Up Down'
  }
  // txnId: 3b15381b-c0ba-4173-a521-90c9d21712dc
  // roundId: 1761027552.4890373
}
